import NodeConnections from './mesh/connections.ts';
import {InternalRelays} from './mesh/relays.ts';
import restDirectory from './mesh/rest-directory/routes.ts';
import {meshRelays} from './mesh/ws/relays/core.ts';
import {meshCluster} from './mesh/ws/cluster/core.ts';
import type {ServerConfigurer, ServerWebSocketOptions} from '@interopio/gateway-server/web/server';
import {GatewayServer} from '@interopio/gateway-server';
import {IOGateway} from '@interopio/gateway';

export const mesh = async (
    options: {
        logger: IOGateway.Logging.Logger,
        enabled?: boolean,
        timeout?: number,
        socket: ServerWebSocketOptions
    },
    configurer: ServerConfigurer,
    config: GatewayServer.ServerConfig
) => {
    const {enabled, logger} = options;
    if (enabled !== true) {
        logger.debug(`no mesh`);
        return;
    }
    let {socket, timeout} = options;
    const authorize = socket.authorize ?? {access: config.auth.type === 'none' ? 'permitted' : 'authenticated'};
    socket = {ping: 30000, authorize: authorize, ...socket};
    timeout ??= 60000; // default timeout is 60 seconds
    const connections = new NodeConnections(logger, timeout);
    const relays = new InternalRelays(logger);

    restDirectory({connections, authorize}, configurer);
    configurer.socket(
        {
            path: '/cluster', options: socket,
            factory: meshCluster({logger, relays})
        },
        {
            path: '/relays', options: socket,
            factory: meshRelays({logger, internal: relays})
        }
    );
}
